import axios from 'axios';
import store from '../../../store';
import {FORM_NAME_ENUMS} from '@/shared-modules/variables/form-name.enums';
import {smallNotification} from '@/shared-modules/services/gf.notification.service';
import qs from 'qs';
import { i18n } from '@/i18n';

export default {
    getExistingCiCdVariables(alias) {
        return axios.get(`/company/${alias}/setting/edit-cicd-variable`).then((res) => {
            store.dispatch('setExistingCiCdVariables',
                {
                    formName: FORM_NAME_ENUMS.COMPANY_SETTING_CI_CD_FORM,
                    variables: res.data
                }
            )
            return res.data;
        });
    },
    starCompany(alias, params) {
        return axios
            .post(`/api/company/${alias}/star`, params)
            .then((res) => {
                if (!params?.starred) {
                    smallNotification('success', {title: i18n.t('message.addStarred')});
                } else {
                    smallNotification('success', {title: i18n.t('message.removeStarred')});
                }
                return res?.data;
            })
            .catch((err) => {
                smallNotification('danger', {title: i18n.t('message.error_occured')});
                throw err;
            });
    },
    leaveCompany(alias, data, params) {
        return axios
            .post(`/api/company/${alias}/leave`, data, {
                params,
                formName: FORM_NAME_ENUMS.LEAVE_COMPANY
            })
            .then((res) => {
                smallNotification('success', {
                    title: i18n.t('message.companyLeave', {title: alias})
                });
                return res?.data;
            })
            .catch((err) => {
                throw err;
            });
    },
    reportCompany(alias, data, params) {
        return axios
            .post(`/api/company/${alias}/report`, data, {
                params,
                formName: FORM_NAME_ENUMS.REPORT_COMPANY
            })
            .then((res) => {
                smallNotification('success', {title: i18n.t('message.reportIsSent')});
                return res?.data;
            })
            .catch((err) => {
                throw err;
            });
    },
    editCiCdVariables(alias, data) {
        return axios
            .post(
                `/company/${alias}/setting/edit-project-cicd-variables`,
                qs.parse(data),
                {
                    formName: FORM_NAME_ENUMS.COMPANY_SETTING_CI_CD_FORM
                }
            )
            .then((res) => {
                store.dispatch('setExistingCiCdVariables',
                    {
                        formName: FORM_NAME_ENUMS.COMPANY_SETTING_CI_CD_FORM,
                        variables: res.data.existingVariables
                    }
                )
                smallNotification('success', {title: 'Переменные сохранены!'});
                this.getExistingCiCdVariables(alias);
                return res.data;
            })
            .catch((err) => {
                smallNotification('danger', {title: 'Произошла ошибка!'});
                throw err;
            });
    }
};
